import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Hotel Home Service
 * Otel ana sayfa (home) için gerekli section API isteklerini yönetir.
 * Tüm metodlar POST çağrısı yapar ve aynı imzayı paylaşır.
 *
 * Not: Endpoint URL'leri `API_URLS.hotel.home.*` altında beklenir.
 * URL değerleri ayrı dosyada tanımlanacağından burada sadece anahtarlar kullanılır.
 */
export const hotelHomeService = {
  /**
   * Popüler tatil bölgelerini getirir
   * @param {Object} payload - API payload
   * @param {string} [payload.LanguageCode] - Dil kodu (örn: "tr", "en")
   * @param {string} [payload.CurrencyCode] - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Özel hata yönetimi kullanılsın mı
   * @returns {Promise<any>} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY"
   * }
   */
  getPopularHolidayAreas: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.hotel.home.getPopularHolidayAreas,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler otelleri getirir
   * @param {Object} payload - API payload
   * @param {string} [payload.LanguageCode] - Dil kodu
   * @param {string} [payload.CurrencyCode] - Para birimi kodu
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Özel hata yönetimi kullanılsın mı
   * @returns {Promise<any>} API response
   */
  getPopularHotels: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.hotel.home.getPopularHotels,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler destinasyonları getirir (otel odaklı)
   * @param {Object} payload - API payload
   * @param {string} [payload.LanguageCode] - Dil kodu
   * @param {string} [payload.CurrencyCode] - Para birimi kodu
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Özel hata yönetimi kullanılsın mı
   * @returns {Promise<any>} API response
   */
  getPopularDestinations: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.hotel.home.getPopularDestinations,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler uluslararası otelleri getirir
   * @param {Object} payload - API payload
   * @param {string} [payload.LanguageCode] - Dil kodu
   * @param {string} [payload.CurrencyCode] - Para birimi kodu
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Özel hata yönetimi kullanılsın mı
   * @returns {Promise<any>} API response
   */
  getPopularInternationalHotels: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.hotel.home.getPopularInternationalHotels,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler uluslararası destinasyonları getirir (otel odaklı)
   * @param {Object} payload - API payload
   * @param {string} [payload.LanguageCode] - Dil kodu
   * @param {string} [payload.CurrencyCode] - Para birimi kodu
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Özel hata yönetimi kullanılsın mı
   * @returns {Promise<any>} API response
   */
  getPopularInternationalDestinations: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.hotel.home.getPopularInternationalDestinations,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler ülkeleri getirir (otel aramalarına göre)
   * @param {Object} payload - API payload
   * @param {string} [payload.LanguageCode] - Dil kodu
   * @param {string} [payload.CurrencyCode] - Para birimi kodu
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Özel hata yönetimi kullanılsın mı
   * @returns {Promise<any>} API response
   */
  getPopularCountries: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.hotel.home.getPopularCountries,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Otel temalarını getirir (ör. balayı, spa, deniz manzaralı vb.)
   * @param {Object} payload - API payload
   * @param {string} [payload.LanguageCode] - Dil kodu
   * @param {string} [payload.CurrencyCode] - Para birimi kodu
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Özel hata yönetimi kullanılsın mı
   * @returns {Promise<any>} API response
   */
  getHotelThemes: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.hotel.home.getHotelThemes,
      payload,
      headers,
      hasErrorHandler,
    }),
};

export default hotelHomeService;


